export default "__VITE_ASSET__xgMEPGHv__"